import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { setData } from 'src/storage/general.actions';

@Component({
  selector: 'app-otro-producto',
  templateUrl: './otro-producto.component.html',
  styleUrl: './otro-producto.component.scss'
})
export class OtroProductoComponent {
  private store = inject(Store);
  private router = inject(Router);

  cleanStore() {
    this.store.dispatch(setData({
      key: 'Property',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'Tenant',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'PolicyHolder',
      value: undefined,
      merge: false
    }));
  }

  goBack() {
    this.cleanStore();
    this.router.navigate(['/seguros/hogar/arriendo/cotizador']).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }
}
